import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form } from "../../../../components/ui/form";
import { Button } from "../../../../components/ui/button";
import { SheetTitle } from "../../../../components/ui/sheet";
import { useToast } from "../../../../hooks/use-toast";
import { FormInput } from "../../../../components/form-components/form-input.components";
import { useEffect } from "react";
import Spinner from "../../../../components/spinner.components";
import InfoIcon from "../../../../assets/svgs/common/info.svg";
import { useVerifyGstAdminHttp } from "../../../../hooks/http/admin/vendors/verify-gst.admin.http";
import { handleHttpError } from "../../../../utils/utils";
// import useVendorStore from "../../../../store/vendor.store";
import { useParams } from "react-router-dom";

const FormSchema = z.object({
  gst: z
    .string()
    .min(15, { message: "Enter valid GST number" })
    .max(15, { message: "Enter valid GST number" }),
});

export default function AddGSTAdminPartial() {
  const { execute: verifyGstHttp, fetching: verifyingGst } =
    useVerifyGstAdminHttp();

  const { toast } = useToast();
  const { vendorId } = useParams();

  // const { setData: setVendor } = useVendorStore();

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      gst: "",
    },
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    if (!vendorId) {
      return;
    }
    const response = await verifyGstHttp({
      body: {
        gst: data.gst,
      },
      pathParams: {
        vendorId,
      },
    });

    if (!response.success) {
      return handleHttpError(response, toast);
    }

    console.log("Form submitted:", data);
    toast({
      content: "GST verified successfully",
      toastType: "success",
    });
    // setVendor(response.data);
    document.getElementById("closeSheet")?.click();
  }

  // Show form validation errors as toast
  useEffect(() => {
    if (form.formState.errors) {
      const key = Object.keys(form.formState.errors)[0];
      if (key) {
        toast({
          content:
            form.formState.errors[key as keyof typeof form.formState.errors]
              ?.message || "",
          toastType: "error",
        });
      }
    }
  }, [form.formState.errors, toast]);

  return (
    <div className="flex flex-col w-full h-full">
      <SheetTitle className="p-5 border-b border-border font-semibold text-2xl text-white">
        Add GST
      </SheetTitle>

      <div className="flex flex-col gap-10 p-5 w-full h-full">
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="flex flex-col justify-between gap-8 w-full h-full"
          >
            <div className="flex flex-col gap-6 w-full">
              {/* GST */}
              <FormInput
                name="gst"
                label="Enter GST number"
                placeholder="GST"
                form={form}
                required
                type="text"
              />
            </div>
            <div className="flex flex-col gap-5 w-full">
              <Button className="flex items-center gap-2 bg-tertiarybuttonbg py-7 border border-border">
                <InfoIcon />
                Add GST registered with the same pan number
              </Button>

              {/* Submit Button */}
              <Button
                disabled={verifyingGst || !form.formState.isValid}
                type="submit"
                className="flex gap-2 bg-primarybuttonbg py-8 w-full font-semibold text-primarybuttontext"
              >
                {verifyingGst ? <Spinner width={20} /> : "Add GST →"}
              </Button>
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
}
